import { render, staticRenderFns } from "./LogDetails.vue?vue&type=template&id=46642ab5&scoped=true&"
import script from "./LogDetails.vue?vue&type=script&lang=js&"
export * from "./LogDetails.vue?vue&type=script&lang=js&"
import style0 from "./LogDetails.vue?vue&type=style&index=0&id=46642ab5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46642ab5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/acarmichael/Desktop/DEV/BOSS40-FrontEnd/boss-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VDialog,VDivider,VFlex,VIcon,VLayout,VList,VListTile,VListTileContent})
